<div class="blackout" [ngClass]="{ 'hide': !modalService.show() }" (click)="closeModal()" #modalBox>&nbsp;</div>